<template>
    <span :class="config.ui">
        <span v-for="(line, index) in safeLines" :key="index" class="block truncate">
            {{ line }}
        </span>
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { LinesBlockConfig } from '~~/layers/base/types/blockConfigs'

const props = defineProps<{
    config: LinesBlockConfig
}>()

const safeLines = computed(() => (props.config.lines.length > 0 ? props.config.lines : ['']))
</script>
